import InputPercentage from './InputPercentage';

export default InputPercentage;
